var _path, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeedSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 84,
    viewBox: "0 0 92 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9066 27L11.1984 27L-1.19209e-06 40.2042L11.3041 53.25H46.9595C47.1444 49.1567 47.25 45.0634 47.25 40.9437C47.25 36.2694 47.1444 31.6743 46.9066 27Z",
    fill: "url(#paint0_linear_2547_10000)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    transform: "matrix(-1 0 0 1 91.9004 0)",
    fill: "url(#paint1_linear_2547_10000)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2547_10000",
    x1: 47.8023,
    y1: 40.125,
    x2: 1.1165,
    y2: 40.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07A0D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046085"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2547_10000",
    x1: 42,
    y1: -0.981836,
    x2: 42,
    y2: 82.0151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07A0D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046085"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedSpinner);
export default __webpack_public_path__ + "static/media/speedSpinner.b4d8b636c148f8d99763b6ef2f2bd8b9.svg";
export { ForwardRef as ReactComponent };